import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material';
import { Box } from '@mui/system';
import { lighten } from '@mui/material/styles';

var secondaryBackground = function (_a) {
    var theme = _a.theme;
    return "\n  background: ".concat(lighten(theme.palette.neutral900, (0x0f - 0x05) / 0xff), ";\n  background: ").concat(theme.palette.backgrounds.secondaryBackground, ";\n");
};
var Layout = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: row;\n  position: sticky;\n  top: var(--header-height, 52px);\n  width: 100%;\n  right: 0;\n  left: 0;\n  ", ";\n  z-index: 50;\n"], ["\n  flex-direction: row;\n  position: sticky;\n  top: var(--header-height, 52px);\n  width: 100%;\n  right: 0;\n  left: 0;\n  ", ";\n  z-index: 50;\n"])), secondaryBackground);
var Container = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  margin: 0 auto;\n  & > * {\n    flex: 1;\n    border-right: 1px dotted ", ";\n  }\n  &:first-child {\n    border-left: 1px dotted ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin: 0 auto;\n  & > * {\n    flex: 1;\n    border-right: 1px dotted ", ";\n  }\n  &:first-child {\n    border-left: 1px dotted ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral600;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral600;
});
var Option = styled("span", {
    shouldForwardProp: function (p) { return p !== "active"; },
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s;\n\n  & > * {\n    transition: color 0.2s;\n    color: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n    background: ", ";\n    & > * {\n      color: ", ";\n    }\n  }\n"], ["\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s;\n\n  & > * {\n    transition: color 0.2s;\n    color: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n    background: ", ";\n    & > * {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme, active = _a.active;
    return active ? theme.palette.highlighted : theme.palette.neutral300;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.backgrounds.manageServiceMenuHover;
}, function (_a) {
    var theme = _a.theme;
    return lighten(theme.palette.neutral750, (0x1b - 0x16) / 0xff);
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral100;
});
var HeadOption = styled(Option)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: 56px;\n  ", ";\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  height: 56px;\n  ", ";\n\n  ", "\n"])), secondaryBackground, function (_a) {
    var isSubOption = _a.isSubOption, theme = _a.theme;
    return isSubOption
        ? "\n        padding: 0 10%;\n        background: ".concat(theme.palette.neutral800, ";\n      ")
        : "\n        justify-content: center;\n      ";
});
var MenuLink = styled("a")(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isSubOption = _a.isSubOption, theme = _a.theme;
    return !isSubOption &&
        "\n  &:not(:last-of-type) {\n      border-right: 1px dotted ".concat(theme.palette.neutral600, ";\n  }\n  ");
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { Container, HeadOption, Layout, MenuLink, Option };
